<div class="spine-stamping-container">
  <dx-select-box
    (onValueChanged)="spineStampingChanged($event)"
    [dataSource]="dataSource"
    [searchEnabled]="false"
    [value]="selectedSpineStamping"
    label="Spine Stamping"
    style="caret-color: transparent"
    stylingMode="filled"
  ></dx-select-box>

  <dx-number-box
    (onValueChanged)="additionalSqnChanged($event)"
    [disabled]="selectedSpineStamping !== 'Stamping sqn'"
    [max]="72"
    [min]="1"
    [value]="additionalSqn || 0"
    label="Stamping sqn"
    stylingMode="underlined"
  ></dx-number-box>
</div>
